import { collection, doc, Timestamp, writeBatch } from "firebase/firestore";
import { omit } from "lodash";
import { db } from "shared/api/firebase";
import { PageModuleDataToInsert } from "../types";
import { copyContentBlockImages } from "./copyContentBlockImages";

export const bulkCreateModulesByBrandPage = async (
  brandId: string,
  pageId: string,
  modules: PageModuleDataToInsert[],
): Promise<void> => {
  const batch = writeBatch(db);

  await Promise.all(
    modules.map(async (module) => {
      const collectionRef = collection(
        db,
        `brands/${brandId}/pages/${pageId}/modules`,
      );

      const docRef = doc(collectionRef);

      const copiedContentBlocks = await copyContentBlockImages(
        module,
        `moduleTemplates/${module.id}`,
        `brands/${brandId}/pages/${pageId}/modules/${docRef.id}`,
      );

      batch.set(docRef, {
        ...omit(module, ["id"]),
        baseUrl: module.baseUrl ?? "",
        contentBlocks: copiedContentBlocks,
        topPrivacyTipsBlock: module.topPrivacyTipsBlock
          ? module.topPrivacyTipsBlock
          : null,
        createdAt: Timestamp.now(),
        updatedAt: Timestamp.now(),
      });
    }),
  );

  await batch.commit();
};
